import { Observable } from 'rxjs';
import _ from 'lodash';
import { ActionsObservable } from 'redux-observable';
import { Store } from 'redux';

import { selectCampaigns } from 'entities/campaign/selectors';
import CampaignApi from 'entities/campaign/api';
import { showErrorAction, showMessageAction } from 'containers/Notification/actions';

import {
  INIT,
  initSuccessAction,
  initFailedAction,
  InitAction,
  SET_OPT_IN_STATUS,
  setOptInStatusSuccessAction,
  setOptInStatusFailedAction,
} from './types';

const init = (action$: ActionsObservable<InitAction>, store: Store) =>
  action$.ofType(INIT).mergeMap(() => {
    const state = store.getState();
    const actions = [];
    const campaigns = selectCampaigns(state);

    if (campaigns?.size === 0 || campaigns?.first?.()?.deeds) {
      actions.push(CampaignApi.fetchAll());
    }

    if (actions.length === 0) {
      return Observable.of(initSuccessAction());
    }

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) =>
        Observable.concat(
          Observable.of(initSuccessAction()),
          Observable.of(..._.flatten(resultingActions))
        )
      )
      .catch((e) => Observable.of(initFailedAction(e)));
  });

const setOptInStatus = (action$) =>
  action$.ofType(SET_OPT_IN_STATUS).exhaustMap(({ campaign, user, optIn }) =>
    CampaignApi.update(campaign.id, {
      optedInCompanies: optIn ? [user.organization.id] : [],
    })
      .mergeMap((resultingAction) => [
        resultingAction,
        showMessageAction(`Campaign successfully ${optIn ? 'added' : 'removed'}!`),
        setOptInStatusSuccessAction(),
      ])
      .catch((e) =>
        Observable.of(
          setOptInStatusFailedAction(e),
          showErrorAction('An error occurred. Please try again later.')
        )
      )
  );

export default [init, setOptInStatus];
